// Welle 131 — STRG-Seite, Reiter „rename me": Verträge / Versicherungen / IBAN / Steuernummern / Darlehen / Mietverträge
// direkt aus DB 2 (kleine Tabellen der Daten.xlsm). Zellen direkt änderbar (speichert beim Verlassen des Feldes),
// „Rename-me erkennt" zeigt Präfix/Absender/VNR5, wie die Erkennung die Zeile sieht. Neu → Maske Stammdaten.
import React, { useCallback, useEffect, useState } from "react";
import StammdatenAnlegenDialog from "./StammdatenAnlegenDialog";
import { LABEL, SD_API, sdJson, sdPut } from "./stammdatenApi";
import "./Stammdaten.css";

// Nur-Lesen-Tabellen: ISO-Datum deutsch anzeigen
const anzeige = (v) => (typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v) ? v.split("-").reverse().join(".") : v ?? "");

// „Rename-me erkennt“ als kleine Marken statt Fließtext
function Erkennt({ w }) {
  if (!w) return null;
  const teile = [["Präfix", w.praefix], ["Absender", w.absender], ["VNR5", w.vnr5], ["VERS5", w.vers5], ["Bank", w.bank]].filter(([, v]) => v);
  return (
    <span className="sd-marken">
      {teile.map(([k, v]) => <span key={k} className="sd-marke" title={`${k}: ${v}`}><i>{k}</i>{v}</span>)}
      {w.aktiv === false && <span className="sd-marke aus">gekündigt</span>}
    </span>
  );
}

export default function StammdatenTabelle({ kat, quelle }) {
  const [d, setD] = useState(null);
  const [q, setQ] = useState("");
  const [fehler, setFehler] = useState("");
  const [meldung, setMeldung] = useState("");
  const [neu, setNeu] = useState(false);

  const laden = useCallback(async () => {
    try { setD(await sdJson(`${SD_API}/${kat}`)); setFehler(""); }
    catch (e) { setFehler(String(e.message || e)); }
  }, [kat]);
  useEffect(() => { setD(null); laden(); }, [laden]);

  const speichern = async (row, spalte, wert) => {
    if (String(row[spalte] ?? "") === String(wert)) return;
    try {
      await sdPut(`/${kat}/${row.id}`, { [spalte]: wert });
      setMeldung(`${LABEL[spalte] || spalte} gespeichert.`); setTimeout(() => setMeldung(""), 2500);
      laden();
    } catch (e) { setFehler(String(e.message || e)); }
  };

  const woerter = q.toLowerCase().split(/\s+/).filter(Boolean);
  const zeilen = (d?.zeilen || []).filter((r) => !woerter.length
    || woerter.every((w) => Object.values(r).some((v) => v != null && typeof v !== "object" && String(v).toLowerCase().includes(w))));
  const aktiv = ["db2", "fallback", "vorrang"].includes(quelle);

  return (
    <div className="sd-seite">
      <div className="sd-leiste">
        <b className="sd-titel">{d?.titel || kat}</b>
        <span className={`sd-badge ${aktiv ? "" : "warn"}`}>Quelle: DB 2 (Daten.xlsm){aktiv ? "" : " — Rename-me liest noch DB 1"}</span>
        <input className="sd-in sd-suche" placeholder="Suchen …" value={q} onChange={(e) => setQ(e.target.value)} />
        <span className="sd-klein">{zeilen.length} von {d?.zeilen?.length ?? "…"}</span>
        {!d?.nur_lesen && <button className="sd-btn primary" onClick={() => setNeu(true)}>+ Neuer Eintrag</button>}
      </div>
      {fehler && <div className="sd-fehler">{fehler}</div>}
      {meldung && <div className="sd-ok">{meldung}</div>}
      <div className="sd-tab-wrap">
        <table className={`sd-tab${d?.nur_lesen ? " nur-lesen" : ""}`}>
          <thead><tr><th>Rename-me erkennt</th>{(d?.spalten || []).map((s) => <th key={s}>{LABEL[s] || s}</th>)}</tr></thead>
          <tbody>
            {!d && !fehler && <tr><td colSpan={99} className="sd-leer">Lade …</td></tr>}
            {zeilen.map((r) => (
              <tr key={r.id} className={r._wirksam?.aktiv === false ? "gekuendigt" : ""}>
                <td><Erkennt w={r._wirksam} /></td>
                {d.spalten.map((s) => (
                  <td key={s} title={d.nur_lesen && r[s] != null ? String(r[s]) : undefined}>{d.nur_lesen ? anzeige(r[s]) : (
                    <input className="sd-zelle" defaultValue={r[s] ?? ""} key={`${r.id}-${s}-${r[s] ?? ""}`} title={r[s] != null ? String(r[s]) : ""}
                      onBlur={(e) => speichern(r, s, e.target.value.trim())} />
                  )}</td>
                ))}
              </tr>
            ))}
            {d && !zeilen.length && <tr><td colSpan={(d.spalten || []).length + 1} className="sd-leer">Keine Einträge.</td></tr>}
          </tbody>
        </table>
      </div>
      {neu && <StammdatenAnlegenDialog startKat={kat} onClose={() => setNeu(false)} onGespeichert={() => laden()} />}
    </div>
  );
}
